// extracted by mini-css-extract-plugin
export default {"reel":"ReelLicenseContainer-module_reel__wHOns"};